





































import { FileApi } from "../../api/FileApi";

const baguetteBox = require("baguettebox.js");

export default {
    name: "PhotosViewer",
    props: {
        photos: Array,
        editable: Boolean,
        selector: Boolean,
        automaticallyOpenFirstPhoto: Boolean,
    },
    data() {
        return {
            FileApi: new FileApi(),
        };
    },
    created() {
        let self = this;
        this.$nextTick(function () {
            let gallery = baguetteBox.run(".photo-gallery");
            if (self.automaticallyOpenFirstPhoto) {
                baguetteBox.show(0, gallery[0]);
            }
        });
    },
    methods: {
        togglePhotoSharedStatus: function (photo) {
            photo.shared = !photo.shared;
            this.FileApi.updatePhoto(photo).then(function (res) {
                photo.shared = res.shared;
            });
        },
        togglePhotoSelect: function (photo) {
            photo.selected = !photo.selected;
            this.$forceUpdate();
        },
    },
    watch: {
        photos: {
            immediate: true,
            deep: true,
            handler: function () {
                if (this.selector) {
                    _.each(this.photos, function (photo) {
                        photo.selected = photo.shared;
                    });
                }
            },
        },
    },
};
